import { defineComponent as o, createBlock as n, openBlock as r, unref as l, mergeProps as p, withCtx as v, createElementVNode as m } from "vue";
import { RevIcon as d } from "@ds/components/Icon";
const u = /* @__PURE__ */ o({
  name: "IconHeadset",
  __name: "IconHeadset",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(a) {
    const t = a;
    return (s, e) => (r(), n(l(d), p(t, { "view-box": "0 0 24 24" }), {
      default: v(() => [...e[0] || (e[0] = [
        m("path", {
          "fill-rule": "evenodd",
          d: "M12 3.75a6.251 6.251 0 0 0-6.21 5.534A1.25 1.25 0 0 1 6.75 10.5v5a1.25 1.25 0 0 1-1.25 1.25 3.25 3.25 0 0 1-3.25-3.25v-1a3.251 3.251 0 0 1 2.016-3.008 7.75 7.75 0 0 1 15.468 0A3.251 3.251 0 0 1 21.75 12.5v1a3.251 3.251 0 0 1-2.242 3.09l-.993 1.49a3.75 3.75 0 0 1-3.12 1.67h-.748a2.751 2.751 0 1 1 0-1.5h.747a2.25 2.25 0 0 0 1.873-1.002l.493-.74a1.248 1.248 0 0 1-.51-1.008v-5a1.25 1.25 0 0 1 .96-1.216A6.25 6.25 0 0 0 12 3.75m-6.75 7.018a1.75 1.75 0 0 0-1.5 1.732v1a1.75 1.75 0 0 0 1.5 1.732v-4.464M12 20.25a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5m6.75-9.482v4.464a1.75 1.75 0 0 0 1.5-1.732v-1a1.75 1.75 0 0 0-1.5-1.732",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  u as default
};
